import * as HttpUtils from 'utils/HttpUtils'
import FormConst from 'constants/FormConst'
import URLConst from 'constants/URLConst'
import { makeAutoObservable } from "mobx"
import CommonConst from 'constants/CommonConst'

/*
 * Module - DocumentStore.js
 *
  * Description : 이지로드 도움말 관련 스터어 입니다. 
 *
 * 작성자 : Choi young ho. 
 * Created on Wed Jul 27 2022
 * Copyright (c) 2022 Renewhouse corp
 */

export default class DocumentStore {
    constructor(root) {
        this.root = root;
        this.documentId = null;
        this.initState();
        makeAutoObservable(this)
    }

    initState = () => {
        this.documentId = null;
        this.lst = []; 
    }

    /**
     * 도움말 목록 검색을 
     * 서버에 요청 합니다. 
     * @param {*} searchField 
     * @param {*} searchKeyword
     * @param {*} pageNo 
     * @param {*} pageAmount 
     * @param {*} regState 
     * @returns 
     */
    doSearch = async ({
        regState
    }) => {
        let param = {};
        
        if(regState)
            param[FormConst.REG_STATE] = CommonConst.DATA_REG_STATE_NORMAL;
        
        let result = await HttpUtils.doPostFormData(
            URLConst.DOCUMENT_LIST_DATA, 
            param
        );
        return result;
    }

    
    doGetDocumentInfo = async({
        documentId
    }) => {
        let param = {};
        param[FormConst.DOCUMENT_ID] = documentId;
        
        let result = await HttpUtils.doPostFormData(
            URLConst.DOCUMENT_FUNC_DESC_DATA, 
            param
        );
        return result;
    }
    
    /**
     * 도움말 관련 
     * 이미지 목록 등록을 
     * 서버에 요청 합니다. 
     * @param documentId : 문서 고유번호 
     * @param imgList : 문서 관련 이미지 배열 
     */
    doInsertImg = async ({
        documentId, 
        imgList, 
    }) => {
        let param = {};
        param[FormConst.DOCUMENT_ID] = documentId;
        param[FormConst.DOCUMENT_IMAGE_LIST] = JSON.stringify(imgList);
        let result = await HttpUtils.doPostFormData(
            URLConst.DOCUMENT_IMAGE_UPLOAD_DATA, 
            param
        );
        return result;
    }

    doUpdate = async ({
        documentId,
        documentFuncDesc, 
        imgIdList, 
    }) => {
        let param = {};
        param[FormConst.DOCUMENT_ID] = documentId;
        param[FormConst.DOCUMENT_DESC] = documentFuncDesc;
        param[FormConst.DOCUMENT_IMG_ID_LIST] = JSON.stringify(imgIdList);
        let result = await HttpUtils.doPostFormData(
            URLConst.DOCUMENT_FUNC_DESC_UPDATE_DATA, 
            param
        );
        console.log("Param", param);
        return result;
    }
}